import { useQuery } from "@tanstack/react-query";

import { getItineraryCustomerOutput } from "../repo/itineraryRepo";
import { derivePublicItinerary } from "../service/itineraryOutputService";
import type { ItineraryEditor } from "../types";

/** 按服务端版本读取侧栏预览，草稿修改与迟到的旧版本响应均不进入当前预览。 */
export function useItinerarySidePreview(
  itineraryId: string,
  savedRevision: string | undefined,
  loadEditor: () => Promise<ItineraryEditor>,
  refreshSequence = 0,
) {
  return useQuery({
    queryKey: ["itinerary", "side-preview", itineraryId, savedRevision, refreshSequence],
    queryFn: async ({ signal }) => {
      const [editor, customerOutput] = await Promise.all([
        loadEditor(),
        getItineraryCustomerOutput(itineraryId, signal),
      ]);
      return derivePublicItinerary(editor, customerOutput);
    },
    retry: false,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
  });
}
